import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getProductFeatureContentHandler } from "../../redux/action/getProductFeatureContentSlice";
import Loader from "../../components/Loder/loader";
import { getGroupProductFeatureContentHandler } from "../../redux/action/getGroupProductFeatureContent";
import { BreadCrum } from "../../common";
import { fileUploadAction } from "../../redux/action/fileUpload";
import GroupDragger from "../Dragger/groupDragger";
import Dragger from "../Dragger/Dragger";
import { removeItem } from "../../common/localStorage";
import {
  isGroupProductFeatureContext,
  navigateToProductParent,
  shouldShowManageProductsBreadcrumb,
} from "./productNavigation";

const PlanInformation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const [deleteUploadedFile, setDeleteUploadedFile] = useState("")
  const { state } = location

  const getProductFeatureContentSelector = useSelector((state) => state?.getProductFeatureContentMain)
  const getGroupProductFeatureContent = useSelector((state) => state?.getGroupProductFeatureContent)

  let getFeatureFromGroup = getGroupProductFeatureContent?.data?.data

  useEffect(() => {
    if (state?.fromGroupData?.id) {
      let payload1 = {
        groupProductFeatureId: state?.fromGroupData?.id
      }
      dispatch(getGroupProductFeatureContentHandler(payload1))
    } else {
      let payload = {
        productId: state?.productId || state?.item?.productId,
        refFeatureId: state?.refFeatureId || state?.item?.refFeatureId
      }
      dispatch(getProductFeatureContentHandler(payload))
    }
  }, [state])

  return (
    <>
      {getProductFeatureContentSelector?.isLoading === true && <Loader loaderTransForm="loaderTransForm" />}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Manage Product</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              { text: isGroupProductFeatureContext(state, getFeatureFromGroup) ? BreadCrum.GROUPS : BreadCrum.PRODUCTS, onClick: () => { navigate(isGroupProductFeatureContext(state, getFeatureFromGroup) ? "/groups" : "/product"); removeItem("productId"); dispatch(fileUploadAction.fileUploadInfoReset()) } },
              {
                text: shouldShowManageProductsBreadcrumb(state, getFeatureFromGroup) ? BreadCrum.MANAGE_PRODUCTS : BreadCrum.ADD_PRODUCT, onClick: () => {
                  dispatch(fileUploadAction.fileUploadInfoReset())
                  navigateToProductParent(navigate, state, getFeatureFromGroup);
                }
              },
              ...(isGroupProductFeatureContext(state, getFeatureFromGroup) && getFeatureFromGroup?.productName ? [{ text: getFeatureFromGroup.productName }] : []),
              { text: BreadCrum.PLAN_INFORMATION, active: true },
            ]}
          />
          <div className="table-padding mb-30">
            <div className="headtitle justify-content-start">
              <div className="lineafter">
                <div className="productname">Product Name</div>
                <div className="producttitle">{state?.productData?.productName || getProductFeatureContentSelector?.data?.data?.productName || getGroupProductFeatureContent?.data?.data?.productName}</div>
              </div>
              <p className="mb-0 heedprodct">{state?.item?.featureName|| state?.fromGroupData?.featureName || state?.featureName}</p>
            </div>
          </div>
          {state?.fromGroupData?.id ? (
            <GroupDragger deleteUploadedFile={deleteUploadedFile} setDeleteUploadedFile={setDeleteUploadedFile} state={state} />
          ) : (
            <Dragger deleteUploadedFile={deleteUploadedFile} setDeleteUploadedFile={setDeleteUploadedFile} state={state} />
          )}
        </div>
      </div>
    </>
  );
};

export default PlanInformation;
